<template>
    <div class="ah-page remittances-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>發票字軌管理</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-header gray">
                    <div class="panel-title">
                        <div style="font-size: 10pt;">在此新增已購買的發票字軌</div>
                    </div>
                    <div class="panel-action">
                        <el-button v-if="!isQR()" type="highlight" @click="handleAdd">新增字軌</el-button>
                    </div>
                </div>
                <div class="panel-body">
                    <div style="margin-bottom: 20px;">
                        <el-select v-model="queryParams.YER" placeholder="選擇年份" @change="handleYearChange" style="margin-right: 10px;">
                            <el-option label="不限年份" :value="null" :key="null"></el-option>
                            <el-option v-for="y in yearOptions" :label="`${y - 1911} 年`" :value="y" :key="'invoice-serial-select-year-' + y"></el-option>
                        </el-select>
                        <el-input v-model="queryParams.PREFIX" style="width: 300px; margin-right: 10px" placeholder="字軌關鍵字" :clearable="true"></el-input>
                        <el-button type="primary" @click="handleSearchBtnClick" :loading="isLoading">查詢</el-button>
                    </div>
                    <el-table v-loading="isLoading" :data="datas" style="width: 100%" class="ah-el-data-table" empty-text="沒有資料" default-expand-alsl>
                        <el-table-column label="年份" width="100" prop="yer">
                            <template slot-scope="scope"> {{ scope.row.yer - 1911 }} 年 </template>
                        </el-table-column>
                        <el-table-column label="類型" width="150">
                            <template slot-scope="scope">
                                <span v-if="scope.row.prefixType === 1">手開發票</span>
                                <span v-if="scope.row.prefixType === 2">電子發票串接</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="期別" width="150">
                            <template slot-scope="scope">
                                <div>
                                    <span v-if="scope.row.moN_TYP === 1">1 ～ 2 月</span>
                                    <span v-if="scope.row.moN_TYP === 2">3 ～ 4 月</span>
                                    <span v-if="scope.row.moN_TYP === 3">5 ～ 6 月</span>
                                    <span v-if="scope.row.moN_TYP === 4">7 ～ 8 月</span>
                                    <span v-if="scope.row.moN_TYP === 5">9 ～ 10 月</span>
                                    <span v-if="scope.row.moN_TYP === 6">11 ～ 12 月</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="字軌號碼(起)" width="150">
                            <template slot-scope="scope">
                                <span class="strong">{{ scope.row.startPrefix }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="字軌號碼(訖)">
                            <template slot-scope="scope">
                                <span class="strong">{{ scope.row.endPrefix }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="100">
                            <template slot-scope="scope">
                                <el-button v-if="!isQR()" size="mini" @click="handleEdit(scope.row)">編輯</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        layout="prev, pager, next"
                        :page-size.sync="queryParams.PageSize"
                        :total.sync="totalDataCount"
                        :current-page.sync="queryParams.PageNum"
                        :small="isMobile()"
                        @current-change="updateData"
                        class="pagination"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>

        <InvoiceSerialNumberDialog
            ref="InvoiceSerialNumberDialog"
            :visible="editDialog.visible"
            :mode="editDialog.mode"
            :target="editDialog.target"
            :queryYER="queryParams.YER"
            @afterSubmit="handleAfterSubmit"
            @afterDelete="handleAfterDelete"
            @close="handleDialogClose"
        />
    </div>
</template>

<script>
import InvoiceSerialNumberDialog from '@/components/dashboard/Finance/InvoiceSerialNumber/InvoiceSerialNumberDialog.vue';

export default {
    name: 'invoice-serial-number',
    components: { InvoiceSerialNumberDialog },
    data() {
        return {
            queryParams: {
                YER: new Date().getFullYear(),
                PREFIX: null,
                PageSize: 25,
                PageNum: 1,
            },
            totalDataCount: null,
            yearOptions: [],
            editDialog: {
                visible: false,
                mode: 'CREATE',
                target: null,
            },

            isLoading: false,
            datas: [],
        };
    },
    mounted() {
        this.fetchYearOptions();

        if (this.queryParams.YER) this.updateData();
    },
    computed: {
        startDateForDisplay() {
            if (this.queryParams.PDAT_Start) {
                return new Date(this.queryParams.PDAT_Start);
            }
            return null;
        },
        endDateForDisplay() {
            if (this.queryParams.PDAT_End) {
                return new Date(this.queryParams.PDAT_End);
            }
            return null;
        },
    },
    methods: {
        async fetchYearOptions() {
            const resp = await this.$api({
                url: '/InvoicePrefix/GetYearOptions',
                method: 'GET',
            });
            this.yearOptions = resp.data.options.reverse();
        },

        async updateData() {
            this.isLoading = true;
            try {
                const resp = await this.$api({
                    url: '/InvoicePrefix/GetList',
                    params: this.queryParams,
                    method: 'GET',
                });

                console.log('invoice-serial-number', resp);
                this.totalDataCount = resp.data.totalNum;
                this.datas = resp.data.list;
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },

        handleYearChange() {
            this.updateData();
        },
        handleSearchBtnClick() {
            this.updateData();
        },

        // events toggling dialog
        handleDialogOpen() {
            this.editDialog.visible = true;
        },
        handleDialogClose() {
            this.editDialog.visible = false;
            this.editDialog.target = null;
        },

        // events to toggle dialog
        handleAdd() {
            this.editDialog.mode = 'CREATE';
            this.handleDialogOpen();
        },
        handleEdit(data) {
            this.editDialog.mode = 'EDIT';
            this.editDialog.target = data;
            this.handleDialogOpen();
        },

        // events after actions form dialog
        handleAfterSubmit(submitYer) {
            if (this.yearOptions.indexOf(submitYer) === -1) {
                this.fetchYearOptions();
            }

            this.queryParams.YER = submitYer;
            this.updateData();
        },
        handleAfterDelete(submitYer) {
            this.queryParams.YER = submitYer;
            this.updateData();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
</style>
